import { DateFilter } from './date-filter';
import { DateFilterComponent } from './date-filter.component';
import { FormFieldHeaderColumn } from '../../common/register/form-field-header/form-field-header-column';

export class DateHeaderColumn extends FormFieldHeaderColumn {
  description: string;
  dateRange: boolean;
  start: boolean;
  end: boolean;

  constructor(item, options?) {
    super(item);
    this.description = item.description;

    this.dateRange = options ? options.dateRange : false;
    this.start = options ? options.start : false;
    this.end = options ? options.end : false;

    if (options && options.start) {
      this.title = `${item.description} Start`;
    } else if (options && options.end) {
      this.title = `${item.description} End`;
    }

    this.filter = new DateFilter(null, null, DateFilterComponent);
  }
}
